import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class ApiService {

  constructor(private _authService: AuthService, private http: Http) { }

  search(query) {
    return this._authService.get('search', query);
  }

  getSearchResource(type, uuid) {
    return this._authService.get(type + '/' + uuid);
  }

  setNewPassword(obj) { return this._authService.post('password/new_password', obj); }
  requestPasswordReset(email) { return this._authService.post('passwordreset/mail-token', { email: email }) }
  resetPassword(resetObject) { return this._authService.post('passwordreset/change', resetObject) }

  cityAutocomplete(str) { return this._authService.get('location/autocomplete', '?name=' + str); }

  getFilter() {
    return new Promise((resolve, reject) => {
      this._authService.getUserInfo().then(profile => {
        resolve(this._authService.get('search_feed', '?apiUser=' + profile.uuid));
      }).catch(reject);
    })
  }
  saveFilter(object) { return this._authService.post('search_feed', object); }
  deleteFilter(uuid) { return this._authService.delete('search_feed/' + uuid); }

  getUserOffers(userUuid) { return this._authService.get('user/offers', '?uuid=' + userUuid); }

  getSaleCategories() { return this._authService.get('sale_category'); }
  getHelpCategories() { return this._authService.get('help_category'); }
  getHousingCategories() { return this._authService.get('housing_category'); }
  getJobCategories() { return this._authService.get('job_category'); }
  getJobBranches() { return this._authService.get('job_branche'); }

  disableOffer(type, uuid) { return this._authService.get(type + '/deactivate', '?uuid=' + uuid); }
  activateOffer(type, uuid) { return this._authService.get(type + '/activate', '?uuid=' + uuid); }

  getHelp(uuid?) { return this._authService.get('help/' + uuid); }
  getSale(uuid?) { return this._authService.get('sale/' + uuid); }
  getJob(uuid?) { return this._authService.get('job/' + uuid); }
  getHousing(uuid?) { return this._authService.get('housing/' + uuid); }

  getHelpList() { return this._authService.get('help'); }
  getSaleList() { return this._authService.get('sale'); }
  getJobList() { return this._authService.get('job'); }
  getHousingList() { return this._authService.get('housing'); }

  createHelp(object) { return this._authService.post('create_help_offer', object); }
  createSale(object) { return this._authService.post('create_sale_offer', object); }
  createJob(object) { return this._authService.post('create_job_offer', object); }
  createHousing(object) { return this._authService.post('create_housing_offer', object); }

  updateHelp(object) { return this._authService.put('create_help_offer/' + object.uuid, object); }
  updateSale(object) { return this._authService.put('create_sale_offer/' + object.uuid, object); }
  updateJob(object) { return this._authService.put('create_job_offer/' + object.uuid, object); }
  updateHousing(object) { return this._authService.put('create_housing_offer/' + object.uuid, object); }

  geocodeByGoogle(address) {
    return this.http.get('https://maps.google.com/maps/api/geocode/json?address=' + encodeURIComponent(address)).map(res => res.json()).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/providers/api.service.ts